module.exports = __webpack_public_path__ + "img/media_1.f1a5f8d6.jpg";